import { Button, styled, TextField } from "@mui/material";

export const SearchInput = styled(TextField)({
  borderRadius: "4px",
  fontSize: "12px",
  height: "40px",
  lineHeight: "14.06px",
  backgroundColor: "#F9F9F9",
  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.16)",
  borderBottom: "1px solid #999999 !important",
});
export const TopButton = styled(Button)({
  width: "100%",
  height: "40px",
  lineHeight: "14.06px",
  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.16)",
  borderRadius: "4px",
  fontSize: "11px",
  fontWeight: "inherit",
  background: "#f9f9f9 !important",
  color: "#4EAF51",
  display: "flex",
  justifyContent: "space-around",
});
